import { render, staticRenderFns } from "./AgentsTable.vue?vue&type=template&id=70e8c9d8"
import script from "./AgentsTable.vue?vue&type=script&lang=js"
export * from "./AgentsTable.vue?vue&type=script&lang=js"
import style0 from "./AgentsTable.vue?vue&type=style&index=0&id=70e8c9d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports